import { FixedSizeVector } from "../fixedSizeVector";
export class IntFlatVector extends FixedSizeVector {
    getValueFromBuffer(index) {
        return this.dataBuffer[index];
    }
}
//# sourceMappingURL=intFlatVector.js.map